import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { generalConsultDetailConstants } from './detail.constants';

@Component({
  selector: 'ms-consult-subject',
  templateUrl: './subject.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: GeneralConsultSubjectComponent, multi: true }
  ]
})
export class GeneralConsultSubjectComponent extends BaseValueAccessor<string> {
  readonly screen = generalConsultDetailConstants.subject;
  @Input() turn = -1;
  @Input() readonly = false;
  expandSection = true;
}
